import { toast } from "sonner"

interface Props {
  sampleData: Record<string, string>
}

export function AvailableVariablesPanel({ sampleData }: Props) {
  const variables = Object.keys(sampleData)

  if (variables.length === 0) return null

  const handleCopy = (variable: string) => {
    navigator.clipboard.writeText(variable)
    toast.success(`Copied ${variable}`)
  }

  return (
    <div className="bg-card rounded-xl shadow-sm border border-border p-6">
      <h3 className="text-sm font-semibold text-foreground mb-3">
        Available Variables
      </h3>
      <p className="text-xs text-muted-foreground mb-4">
        Click a variable to copy it. Paste it into the body where you want it to
        appear.
      </p>
      <div className="flex flex-wrap gap-2">
        {variables.map((v) => (
          <button
            key={v}
            onClick={() => handleCopy(v)}
            className="font-mono text-xs bg-indigo-50 text-indigo-700 border border-indigo-200 rounded px-2 py-1 hover:bg-indigo-100 transition-colors cursor-pointer"
          >
            {v}
          </button>
        ))}
      </div>
    </div>
  )
}
